module["exports"] = ["Česká republika"];